import type { FaireProductEntity } from "../../entity_types/product";

export const p_c69w1vd0: FaireProductEntity = {
  token: "p_c69w1vd0",
  type: "product",
  name: "Hand-Blended Infused Sea Salt - 6 Flavor Variety Pack",
  brandToken: "b_4l4trvmb",
  brandName: "Salt Sisters",
  imageUrl:
    "https://cdn.faire.com/fastly/a6080f24c6df57ee25be5cffe3149c01714553355d7c81f94301cd59c705b29b.jpeg",
  galleryImageUrls: [],
  priceDollars: 9.69,
  description:
    "*PLEASE NOTE: We’ve just launched our new branding with updated packaging.  Variety Pack image is not actual packaging. Thank you for your understanding!\n\nVariety Pack includes 24 jars 4 of each flavor.   \n- Butcher's Blend\n- Chili Lime\n- French Herb\n- Lemon Rosemary Garlic\n- Orange Ginger Garlic\n- Sriracha\n\nOur USA made, farm to table products contain no MSG, no preservatives and are non-GMO, making them a great idea for host / hostess gifts or as a way to elevate special events such as game day, family gatherings and holidays.",
  tags: [],
  msrpDollars: 19.39,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:27.282Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
